import { Box, Typography } from "@mui/material";
import React from "react";

const ViewAllottedBids = ({ rfq, bidData, groupedData, groupedWorkItems }) => {
  return (
    <div>
      <Box className="dashboard-container" px={10} mt={4}>
        <Typography variant="h6">Vendor Allocation</Typography>

        {bidData &&
          groupedData &&
          Object.entries(groupedData).map(([vendorKey, bids]) => {
            const vendor = bids[0]?.vendor;

            // Filter bids that have at least one work item with % > 0
            const allottedBids = bids.filter((bid) =>
              bid.bidWorkItems.some((bw) => bw.percentageAllotted > 0 && bw.bidStatus !== "REBID")
            );

            if (allottedBids.length === 0) return null;

            let totalAmountWithTax = 0;

            return (
              <Box key={vendor.vendorId} mt={3}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "bold" }}
                >
                  Vendor: {vendor.name} ({vendor.firmName})
                </Typography>
                <table
                  border={1}
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: "20px" }}>Code</th>
                      <th style={{ width: "400px" }}>Description</th>
                      <th>Alloted Qty</th>
                      <th>Rate (in ₹)</th>
                      <th>GST (in %)</th>
                      <th>Percentage Allotted</th>
                      <th>Amount (Excl. GST)</th>
                      <th>Tax (in ₹)</th>
                      <th>Amount (Incl. GST)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rfq &&
                      allottedBids.map((bid) =>
                        bid.bidWorkItems
                          .filter((bw) => bw.percentageAllotted > 0)
                          .sort((a, b) => {
                            const normalize = (str) =>
                              str?.replace(/\s+/g, " ").trim().toLowerCase();
                            const orderA =
                              rfq?.rfqWorkItems?.find(
                                (item) =>
                                  // item.code === a.code &&
                                  normalize(item.description) ===
                                    normalize(a.description) &&
                                  item.quantity === a.quantity &&
                                  item.unit === a.unit &&
                                  item.gst === a.gst
                              )?.itemOrder || 0;
                            const orderB =
                              rfq?.rfqWorkItems?.find(
                                (item) =>
                                  // item.code === b.code &&
                                  normalize(item.description) ===
                                    normalize(b.description) &&
                                  item.quantity === b.quantity &&
                                  item.unit === b.unit &&
                                  item.gst === b.gst
                              )?.itemOrder || 0;
                            return orderA - orderB;
                          })
                          .map((bw) => {
                            const percent = bw.percentageAllotted || 0;
                            const allocatedQty = bw.quantity * (percent / 100);
                            const allocatedAmount = allocatedQty * bw.rate;
                            const taxAmount = allocatedAmount * (bw.gst / 100);
                            const amountWithTax = allocatedAmount + taxAmount;
                            totalAmountWithTax += amountWithTax;

                            return (
                              <tr key={bw.bwId} style={{ textAlign: "center" }}>
                                <td style={{ padding: "20px" }}>{bw.code}</td>
                                <td>{bw.description}</td>
                                <td>{allocatedQty.toFixed(2)}</td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(bw.rate)}
                                </td>
                                <td>{bw.gst}</td>
                                <td>{percent}</td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(allocatedAmount)}
                                </td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(taxAmount)}
                                </td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(amountWithTax)}
                                </td>
                              </tr>
                            );
                          })
                      )}
                    <tr
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#e0f7fa",
                      }}
                    >
                      <td
                        colSpan={8}
                        style={{ padding: "20px", textAlign: "right" }}
                      >
                        Grand Total (in ₹):
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {new Intl.NumberFormat("en-IN", {
                          style: "decimal",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(totalAmountWithTax)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>
            );
          })}
      </Box>
    </div>
  );
};

export default ViewAllottedBids;
